'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowDown, ChevronRight } from "lucide-react";
import Link from "@/components/ui/Link";
export default function SectionHeader() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2"><ArrowDown size={18} className="text-FFFFFF" /><p className="text-12-tamil-900 text-FFFFFF leading-[1.4] line-clamp-1">இணையக் கதைகள்</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-full"><div className=" w-full bg-012061 border-1 border-2D497E"><div className="flex items-center justify-between px-4 py-3">{t0}<div className="flex items-center gap-1"><p className="text-FFFFFF text-10-tamil-500 line-clamp-1">மேலும்</p><ChevronRight size={16} className="text-FFFFFF" /></div></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}